export function isEmailValid(email) {
    const regex = /^(([^<>()[\].,;:\s@"]+(.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+.)+[^<>()[\].,;:\s@"]{2,})$/i;
    if (email && regex.test(email) === false) {
        return false;
    }
    return true;
}

export function isGolfIdValid(golfId) {
    //Valid format is XXXXXX-XXX, really is should be YYMMDD
    if (golfId && golfId.split('-').length === 2 && golfId.split('-')[0].length === 6 && golfId.split('-')[1].length === 3) {

        return true;
    }
    return false;
}

export function isPostCodeValid(postCode) {
    if (postCode && postCode.length === 5 && /^\d+$/.test(postCode)) {

        return true;
    }
    return false;
}

export function isHandicapValid(handicap) {
    var hcpValue = handicap.replace('+', '').replace(',', '');
    var lastChar = handicap.charAt(handicap.length - 1);
    return !isNaN(hcpValue) &&
        lastChar >= '0' && lastChar <= '9'
}